import { GameIdentity } from '@/components/game/_domain/models';

abstract class JsonStartData {
    public readonly id: number;
    public readonly prize: number;
    public readonly playerCount: number;
    public readonly stripCount: number;
    public readonly now: number;

    constructor(id: number, prize: number, playercount: number, stripcount: number, now: number, gameIdentity?: GameIdentity){
      this.id = id;
      this.prize = prize;
      this.playerCount = playercount;
      this.now = now;
      this.stripCount = stripcount;
    }
  }

abstract class JsonCallData {
    public readonly callNumber: number;
    public readonly callCount: number;

    constructor(callNumber: number, callCount: number){
        this.callCount = callCount;
        this.callNumber = callNumber;
}
}

abstract class JsonCountdownData {
    public readonly id: number;
    public readonly prize: number;
    public readonly playerCount: number;
    public readonly stripCount: number;
    public readonly startTime: number;
    public readonly purchasingOpenTime: number;
    public readonly purchasingCloseTime: number;
    public readonly chatOpenTime: number;
    public readonly chatCloseTime: number;
    public readonly secondsTilStart: number;
    public readonly now: number;

    constructor(id: number, prize: number, playerCount: number, stripCount: number, startTime: number, purchasingOpenTime: number, purchasingCloseTime: number, chatOpenTime: number, chatCloseTime: number, secondsTilStart: number, now: number, gameIdentity?: GameIdentity){
        this.id = id;
        this.prize = prize;
        this.playerCount = playerCount;
        this.stripCount = stripCount;
        this.startTime = startTime;
        this.purchasingOpenTime = purchasingOpenTime;
        this.purchasingCloseTime = purchasingCloseTime;
        this.chatOpenTime = chatOpenTime;
        this.chatCloseTime = chatCloseTime;
        this.secondsTilStart = secondsTilStart;
        this.now = now;
    }
}

abstract class JsonWelcomeData {
    public readonly id: number;
    public readonly startTime: number;
    public readonly secondsTilStart: number;
    public readonly calls: number[];
    public readonly prize: number;
    public readonly playerCount: number;

    constructor(id: number, prize: number, playerCount: number, startTime: number, secondsTilStart: number, calls: number[], gameIdentity?: GameIdentity){
        this.id = id;
        this.startTime = startTime;
        this.secondsTilStart = secondsTilStart;
        this.calls = calls;
        this.playerCount = playerCount;
        this.prize = prize;
    }
}

abstract class JsonWinnersData  {
    public readonly winners: string[];
    public readonly prizeEach: number;
    public readonly prizeTotal: number;
    public readonly now: number;

    constructor(winners: string[], prizeEach: number, prizeTotal: number, now: number){
        this.winners = winners;
        this.prizeEach = prizeEach;
        this.prizeTotal = prizeTotal;
        this.now = now;
    }
}

export {
    JsonCallData,
    JsonCountdownData,
    JsonStartData,
    JsonWelcomeData,
    JsonWinnersData
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/json/prize/json-prize-data.ts